import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { generatePath } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';

import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { Notifications as NotificationsComponent } from 'us-react-components/dist/Notifications/Notifications';
import { useDependencies } from '../../../dependencies';
import { Routes } from '../../../Routes';
import { Link } from '../..';
import NotificationItem from './NotificationItem';

const Notifications = observer((): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { services: { tracker }, stores } = useDependencies();
  const notificationStore = stores.notifications;
  const { user } = stores.user;

  let { unreadNotifications } = notificationStore;

  const id = user.id?.toString() ?? '';
  const [open, setOpen] = useState(false);

  const markAsRead = async (): Promise<void> => {
    if (
      (unreadNotifications && unreadNotifications.length > 5) ||
      !unreadNotifications?.length ||
      notificationStore.unreadNotificationsCount === 0
    ) {
      return;
    }

    notificationStore.markRead(user.id || 0);
    unreadNotifications = notificationStore.unreadNotifications;
  };

  const handleNotificationBellClick = (): void => {
    setOpen(!open);
    markAsRead();
    tracker.track('clicked-button', { elementText: 'header-notifications' });
  };
  const handleNotificationBellBlur = (): void => setOpen(false);

  return (
    <div className='inline-block relative'>
      <NotificationsComponent
        unreadNotificationsCount={notificationStore.unreadNotificationsCount}
        handleBellClick={handleNotificationBellClick}
        handleBellBlur={handleNotificationBellBlur}
      />
      <div
        className={`absolute top-8 w-72 -right-4 sm:right-0 bg-white text-left text-sm border drop-shadow-md rounded mt-2 z-10 active:block ${
          open ? 'block' : 'hidden'
        }`}
      >
        {unreadNotifications?.length ? (
          unreadNotifications.map(n => <NotificationItem data={n} key={n.id || n.promptId || n.label} />)
        ) : (
          <div className='p-4 border-b'>{t('components.notifications.none')}</div>
        )}
        <div>
          <Link
            to={generatePath(Routes.sitter.notifications, { id })}
            className='block font-bold w-full p-4 text-sapphire hover:bg-gray-100 active:bg-gray-200'
          >
            {t('components.notifications.viewAll')}
            <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]' />
          </Link>
        </div>
      </div>
    </div>
  );
});

export default Notifications;
